import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedComic from "./components/FeaturedComic";
import LatestUpdates from "./components/LatestUpdates";
import PopularComics from "./components/PopularComics";
import TrendingSection from "./components/TrendingSection";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "布丁漫画网",
    alternateName: "蜜桃少年漫画",
    url: "https://www.puddingcomic.com",
    description: "通过布丁漫画网免费阅读蜜桃少年看下拉式漫画，在线下拉畅读全集中文故事，享受免费且流畅的浏览体验。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.puddingcomic.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComic />
        <LatestUpdates />
        <PopularComics />
        <TrendingSection />
      </main>
      <Footer />
    </>
  );
}